import React, { useEffect } from "react";
import errorIMG from "../../assets/images/404.svg";

const PageNotFound = ({ setShowSidebar, setShowNavbar }) => {
  useEffect(() => {
    // Hide sidebar and navbar for 404 page
    setShowSidebar?.(false);
    setShowNavbar?.(false);

    // Cleanup function to restore sidebar and navbar when leaving 404 page
    return () => {
      setShowSidebar?.(true);
      setShowNavbar?.(true);
      
      // Ensure the content class is restored when navigating away from 404
      setTimeout(() => {
        const parentElement = document.getElementById("main-content");
        if (parentElement && !parentElement.classList.contains("content")) {
          parentElement.classList.add("content");
        }
      }, 0);
    };
  }, [setShowSidebar, setShowNavbar]);

  return (
    <div className="fixed inset-0 w-full h-screen overflow-hidden bg-white z-50">
      <img src={errorIMG} alt="404 Page Not Found" className="object-cover w-full h-full" />
    </div>
  );
};

export default PageNotFound;
